import { ALL_FIAS_FIELDS, FiasFields, FiasFullValue } from "../FiasWidgetTypes";
import { FiasAddress } from "../../../Utils/FiasAddressUtils";
import { FiasExtendFieldsType, ParsedExtendedFiasField } from "../../../FiasInput/Types/FiasTypes";
import { getIn } from "../../../../../../Helpers/ReduxStateHelpers";
import { acceptHelperConvertationToValue } from "../../../FiasInput/Utils/Convertations/acceptConvertationHelper";
import { isNotNullOrEmpty } from "../../../../../../../../Common/TypingUtils";
import { RegionsType } from "../../../FiasInput/FiasApi";
import { extractRegionCode, findRegionCodeByName } from "../../../FiasInput/Utils/Convertations/Region/Region";

export const resolveWidgetUrl = () => {
    if (window.location.hostname.endsWith(".testkontur.ru")) {
        return "https://cdn-test.kontur.host/environments/Cloud/bundles/addresses.widget/files/loader.js";
    }

    return "https://cdn.kontur.host/environments/Prod/bundles/addresses.widget/files/loader.js";
};

const fiasApiPathToArrayWithData = (fiasApiPath: string): string[] => {
    const fiasApiPathArray = fiasApiPath.split(".");
    if (fiasApiPathArray.length !== 3 || fiasApiPathArray.at(1) !== "data") {
        return fiasApiPathArray.slice(0, 1).concat("data").concat(fiasApiPathArray.slice(1));
    }

    return fiasApiPathArray;
};

const prepareData = (value: string, fiasApiPath: string, regionsList: RegionsType): string | undefined => {
    if (fiasApiPath.startsWith(FiasFields.region) && fiasApiPath.endsWith("code") && isNaN(Number(value))) {
        return extractRegionCode(findRegionCodeByName(value, regionsList));
    }

    return value;
};

export const getFiasFieldValue = (
    fiasFullValue: FiasFullValue,
    extendedField: ParsedExtendedFiasField,
    regionsList: RegionsType
): string => {
    const fiasErrorFieldNames = Object.keys(fiasFullValue.addressErrors ?? {});
    const hasErrors = fiasErrorFieldNames.length > 0;
    const fiasApiPath = extendedField.sourceValue.at(0)?.fiasApiPath ?? "";

    if (extendedField.type === FiasExtendFieldsType.guid) {
        return hasErrors ? "" : fiasFullValue.fiasId;
    }

    if (extendedField.type === FiasExtendFieldsType.index) {
        return isNotNullOrEmpty(fiasFullValue.postalCode)
            ? fiasFullValue.postalCode
            : (fiasFullValue.address.garhouse?.data?.postalCode ?? "");
    }

    if (fiasErrorFieldNames.some(fieldName => (fiasApiPath ?? "").startsWith(String(fieldName)))) {
        // note: для ошибочного номера дома хотим вернуть значение только для поля houseNum
        if (fiasApiPath.startsWith(String(FiasFields.garhouse)) && !fiasApiPath.endsWith("houseNum")) {
            return "";
        }

        const fiasFieldValue = getIn(fiasFullValue.address, [fiasApiPath?.split(".")?.at(0), "text"], "") as string;
        return prepareData(fiasFieldValue, fiasApiPath, regionsList) ?? "";
    }

    let fiasFieldValue = "";
    if (ALL_FIAS_FIELDS.some(it => fiasApiPath.startsWith(String(it)))) {
        fiasFieldValue = getIn(fiasFullValue.address, fiasApiPathToArrayWithData(fiasApiPath), "") as string;
    } else {
        fiasFieldValue = getIn(fiasFullValue, fiasApiPath.split("."), "") as string;
    }

    if (extendedField.sourceValue.at(0)?.convertationMethod) {
        return (
            acceptHelperConvertationToValue(fiasFieldValue, extendedField.sourceValue.at(0)?.convertationMethod) ??
            fiasFieldValue
        );
    }

    return fiasFieldValue;
};

export const fiasFullValueToFiasAddress = (
    fiasFullValue: FiasFullValue,
    extendedFields: ParsedExtendedFiasField[],
    regionsList: RegionsType
): FiasAddress =>
    extendedFields.reduce(
        (acc, extendedField) => ({
            ...acc,
            [extendedField.path]: getFiasFieldValue(fiasFullValue, extendedField, regionsList),
        }),
        {} as FiasAddress
    );
